import StepIcon, { StepState } from './StepIcon';

interface Props {
  steps: { label: string; state: StepState }[];
}

const TranscriptStepper = ({ steps }: Props) => (
  <div className="flex items-start">
    {steps.map((step, i) => (
      <div key={step.label} className="flex items-start">
        {i > 0 && <div className="mt-3.5 h-px w-10 sm:w-20 bg-border" />}
        <div className="flex flex-col items-center gap-1.5 w-max">
          <StepIcon state={step.state} />
          <span className="text-xs text-foreground whitespace-nowrap">
            {step.label}
          </span>
        </div>
      </div>
    ))}
  </div>
);

export default TranscriptStepper;
